import Typography from '@mui/material/Typography';

const PostInfo = ({ body }) => {
  return <Typography display="block" sx={{ color: '#506A96', fontSize: '1rem', letterSpacing: 0 }}>
    {body}
  </Typography>
}

export default PostInfo